// tutorialStore.ts
import { create } from 'zustand';
import Cookies from 'js-cookie';

export type TutorialPage =
  | 'dashboard'
  | 'claims'
  | 'reports'
  | 'statements'
  | 'transactions'
  | 'settings'
  | null;

interface TutorialStore {
  visitedPages: Set<TutorialPage>;
  markPageVisited: (page: TutorialPage) => void;
  isTutorialActive: boolean;
  tutorialCompleted: boolean;
  completeTutorial: () => void;
  startTutorial: () => void;
  restartTutorial: () => void;
}

export const useTutorialStore = create<TutorialStore>((set) => ({
  visitedPages: new Set<TutorialPage>(),
  isTutorialActive: false,
  tutorialCompleted: false,
  markPageVisited: (page: TutorialPage) =>
    set((state) => {
      const newVisited = new Set(state.visitedPages);
      newVisited.add(page);
      return { visitedPages: newVisited };
    }),
  completeTutorial: () => {
    Cookies.set('tutorialCompleted', 'true', { expires: 3650 }); // 10 years
    set({
      isTutorialActive: false,
      tutorialCompleted: true,
    });
  },
  startTutorial: () => {
    Cookies.set('tutorialCompleted', 'false', { expires: 3650 }); // 10 years
    set({ isTutorialActive: true, tutorialCompleted: false });
  },
  restartTutorial: () => {
    Cookies.set('tutorialCompleted', 'false');
    set({
      visitedPages: new Set<TutorialPage>(),
      isTutorialActive: true,
      tutorialCompleted: false,
    });
  },
}));
